export default __webpack_public_path__ + "static/media/photo.db113fef.svg";